var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTether = function SvgIconTether(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconTether_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M31 .5H4A3.5 3.5 0 0 0 .5 4v16A3.5 3.5 0 0 0 4 23.5h27a3.5 3.5 0 0 0 3.5-3.5V4A3.5 3.5 0 0 0 31 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    d: "m11.05 3.238-3.71 7.79c-.03.06-.02.13.03.18l10.02 9.6c.06.06.15.06.21 0l10.02-9.6s.06-.12.03-.18l-3.71-7.79a.16.16 0 0 0-.14-.09H11.18a.15.15 0 0 0-.14.09z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.79 11.83c-.07 0-.44.03-1.27.03-.66 0-1.13-.02-1.29-.03-2.55-.11-4.45-.56-4.45-1.09s1.9-.97 4.45-1.09v1.73c.17.01.64.04 1.3.04.79 0 1.19-.03 1.26-.04V9.65c2.54.11 4.44.56 4.44 1.09s-1.9.97-4.44 1.09m0-2.35V7.93h3.55V5.57h-9.66v2.36h3.55v1.55c-2.88.13-5.05.7-5.05 1.39s2.17 1.25 5.05 1.39v4.97h2.56v-4.97c2.88-.13 5.04-.7 5.04-1.39s-2.16-1.25-5.04-1.39",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconTether_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v24H0z"
  })))));
};
export default SvgIconTether;